export default "__VITE_ASSET__8af64854__"